import React, { useState, useEffect } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Badge } from '../ui/badge';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export default function SubscriptionsTab({ token }) {
  const [active, setActive] = useState([]);
  const [inactive, setInactive] = useState([]);
  const [revenue, setRevenue] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`${API_URL}/api/admin/subscriptions`, {
      headers: { 'Authorization': `Bearer ${token}` }
    })
      .then(res => res.json())
      .then(data => {
        setActive(data.active?.users || []);
        setInactive(data.inactive?.users || []);
        setRevenue(data.total_revenue_estimate || 0);
      })
      .finally(() => setLoading(false));
  }, [token]);

  if (loading) return <div className="text-white">Loading...</div>;

  return (
    <div className="space-y-6">
      <Card className="bg-slate-800 border-slate-700">
        <CardHeader>
          <CardTitle className="text-white">Active Subscriptions ({active.length})</CardTitle>
          <p className="text-green-400 text-sm">Est. Monthly Revenue: £{revenue}</p>
        </CardHeader>
        <CardContent>
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead>
                <tr className="text-slate-400 border-b border-slate-700">
                  <th className="text-left py-3 px-2">Email</th>
                  <th className="text-left py-3 px-2">Name</th>
                  <th className="text-left py-3 px-2">Expires</th>
                </tr>
              </thead>
              <tbody>
                {active.map((user) => (
                  <tr key={user.id} className="border-b border-slate-700/50 text-white">
                    <td className="py-3 px-2">{user.email}</td>
                    <td className="py-3 px-2">{user.full_name || '-'}</td>
                    <td className="py-3 px-2">
                      {user.subscription_expires ? new Date(user.subscription_expires).toLocaleDateString() : '-'}
                    </td>
                  </tr>
                ))}
                {active.length === 0 && (
                  <tr><td colSpan={3} className="py-4 text-center text-slate-400">No active subscriptions</td></tr>
                )}
              </tbody>
            </table>
          </div>
        </CardContent>
      </Card>

      <Card className="bg-slate-800 border-slate-700">
        <CardHeader>
          <CardTitle className="text-white">With Stripe Account (Inactive) ({inactive.length})</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead>
                <tr className="text-slate-400 border-b border-slate-700">
                  <th className="text-left py-3 px-2">Email</th>
                  <th className="text-left py-3 px-2">Name</th>
                  <th className="text-left py-3 px-2">Status</th>
                </tr>
              </thead>
              <tbody>
                {inactive.map((user) => (
                  <tr key={user.id} className="border-b border-slate-700/50 text-white">
                    <td className="py-3 px-2">{user.email}</td>
                    <td className="py-3 px-2">{user.full_name || '-'}</td>
                    <td className="py-3 px-2">
                      <Badge className="bg-slate-500">Inactive</Badge>
                    </td>
                  </tr>
                ))}
                {inactive.length === 0 && (
                  <tr><td colSpan={3} className="py-4 text-center text-slate-400">No inactive users with Stripe</td></tr>
                )}
              </tbody>
            </table>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
